// RxJS
import { delay, distinctUntilChanged } from 'rxjs/operators';
// CRUD
import { QueryResultsModel, BaseDataSource } from '../../_base/crud';
// State
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers';
// Selectors
import { 
    selectGrainTypesInitWaitingMessage, 
    selectGrainTypesInStore, 
    selectGrainTypesPageLoading
} from '../_selectors/grain-stock.selectors';

export class GrainTypesDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();
		this.loading$ = this.store.pipe(
			select(selectGrainTypesPageLoading)
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectGrainTypesInitWaitingMessage)
		);

		this.store.pipe(
			select(selectGrainTypesInStore)
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
